import { Typography, FormControl, Box, SxProps, Theme } from "@mui/material";
import { ReactNode, useEffect, useRef } from "react";

interface FormInputProps {
    children?: ReactNode;
    label?: string;
    sx?: SxProps<Theme>;
    onWidthChange?: (width: number) => void;
    labelWidth?: number;
}

const FormInput = ({
    children,
    label,
    sx,
    onWidthChange,
    labelWidth,
}: FormInputProps) => {
    const labelRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (labelRef.current && onWidthChange) {
            onWidthChange(labelRef.current.offsetWidth);
        }
    }, [label, onWidthChange]);

    const boxAlign: SxProps<Theme> = {
        ...sx,
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "flex-start", sm: "center" },
    };

    return (
        <Box sx={{ ...boxAlign }}>
            <Typography
                variant="subtitle2"
                sx={{ marginX: 1 }}
                ref={labelRef}
                minWidth={labelWidth}
            >
                {label}
            </Typography>
            <FormControl fullWidth size="small" variant="outlined">
                {children}
            </FormControl>
        </Box>
    );
};

export default FormInput;
